import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import LoadingSpinner from '../components/LoadingSpinner';
import { portalService } from '../services/portalService';

const MyChildren = () => {
  const [children, setChildren] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadChildren = async () => {
      try {
        setLoading(true);
        setError('');
        const dashboard = await portalService.getParentDashboard();
        setChildren(dashboard.children || []);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load linked children.');
      } finally {
        setLoading(false);
      }
    };

    loadChildren();
  }, []);

  if (loading) return <LoadingSpinner message="Loading children..." />;

  return (
    <div className="page-container">
      <div className="page-header"><h1>My Children</h1></div>

      {error && <div className="error-message">{error}</div>}

      {children.length === 0 ? (
        <div className="no-data-message">No children linked to your account.</div>
      ) : (
        <div className="card-grid">
          {children.map(child => (
            <div key={child.id} className="class-card">
              <div className="class-card-header">
                <h2>{child.name}</h2>
                <span className="class-room">{child.grade}</span>
              </div>
              <div className="class-card-body">
                <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginTop: '1rem' }}>
                  <Link to="/children-attendance" className="btn btn-secondary" style={{ fontSize: '0.85rem' }}>Attendance</Link>
                  <Link to="/children-grades" className="btn btn-secondary" style={{ fontSize: '0.85rem' }}>Grades</Link>
                  <Link to="/children-assignments" className="btn btn-secondary" style={{ fontSize: '0.85rem' }}>Assessments</Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyChildren;
